
const register = user => localStorage.setItem('user', JSON.stringify(user));

const getUser = () => {
    let user = localStorage.getItem('user');
    if (user) return JSON.parse(user);
    else return null;
}

const clear = () => {
    //console.log('clear');
    localStorage.removeItem('user');

    window.location.reload();
}

export const session = { register, getUser, clear };